import {
    USE_TOKEN,
    REFRESH_TOKEN,
    ACCESS_TOKEN,
    LOGOUT
} from "@/stores/OAuth2Store";

export class VuexTokenStore{
    constructor(store, name) {
        this.store = store;
        this.name = name;
    }

    useToken(accessToken, refreshToken) {
        this.store.commit(`${this.name}/${USE_TOKEN}`, { accessToken, refreshToken });
    }
    getRefreshToken() {
        return this.store.getters[`${this.name}/${REFRESH_TOKEN}`];
    }
    getAccessToken() {
        return this.store.getters[`${this.name}/${ACCESS_TOKEN}`];
    }
    logout() {
        this.store.dispatch(`${this.name}/${LOGOUT}`);
    }
}
